module.exports = __webpack_public_path__ + "img/hiw_vertical.png";